import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rwidget-recover-password-side',
    templateUrl: 'recover-password-aside.component.html'
})

export class RecoverPasswordAsideComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}
